exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo[data-v-4d088a2c]{display:inline-block;min-width:140px\n}\n.logo img[data-v-4d088a2c]{max-width:100%;max-height:50px;padding-top:5px\n}\n#logo-padel[data-v-4d088a2c]{display:none\n}\n.hide[data-v-4d088a2c]{display:none\n}\ni[data-v-4d088a2c]{margin-right:5px;font-size:1.4rem\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d088a2c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Navbar.vue
// module id = 270
// module chunks = 0